import React, { useState, useEffect } from "react";
import products from "./data/products.json";

const ShopPage = () => {
  const [cartItems, setCartItems] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [packageCount, setPackageCount] = useState("");
  const [formData, setFormData] = useState({
    jmeno: "",
    email: "",
    telefon: "",
    firma: "",
    adresa: "",
  });

  useEffect(() => {
    const storedCart = localStorage.getItem("visionhome_cart");
    if (storedCart) setCartItems(JSON.parse(storedCart));
  }, []);

  useEffect(() => {
    localStorage.setItem("visionhome_cart", JSON.stringify(cartItems));
  }, [cartItems]);

  // Vyparsuje hodnotu a jednotku z "Balení: 25 kg" / "100 ks" / "5 l"
  const parsePackage = (text) => {
    const valueMatch = text.match(/(\d+(\.\d+)?)/);
    const unitMatch = text.match(/(kg|l|ks)/i);
    const value = valueMatch ? parseFloat(valueMatch[0]) : 1;
    const unit = unitMatch ? unitMatch[0].toLowerCase() : "ks";
    return { value, unit };
  };

  // Přidání do košíku – cena = (počet balení × jednotky v balení) × cena za 1 jednotku s DPH
const addToCart = (product, count) => {
  const parsedCount = Math.max(1, parseInt(count, 10) || 1);

  // 📦 Čteme přesně jen část po "Množství:"
  const quantitySection = product.package.split("Množství:").pop().trim();
  const valueMatch = quantitySection.match(/(\d+(?:\.\d+)?)/);
  const unitMatch = quantitySection.match(/(kg|l|ks|m)$/i);

  const value = valueMatch ? parseFloat(valueMatch[1]) : 1;
  const unit = unitMatch ? unitMatch[1].toLowerCase() : "ks";

  const totalUnits = parsedCount * value;
  const totalPrice = parsedCount * value * product.unit_price_with_vat;

  const newItem = {
    ...product,
    id: `${product.sku}-${Date.now()}`,
    packageCount: parsedCount,
    valuePerPack: value,
    unit,
    totalUnits,
    totalPrice,
  };

  setCartItems((prev) => [...prev, newItem]);
  setSelectedProduct(null);
  setPackageCount("");
};



  const removeFromCart = (id) => {
    setCartItems((prev) => prev.filter((item) => item.id !== id));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const totalPrice = cartItems.reduce((acc, item) => acc + item.totalPrice, 0);

  // Odeslání poptávky z košíku (FormSubmit – doplníte email po / )
  const handleSubmit = async (e) => {
  e.preventDefault();

  const html = `
    <h2>🧾 Nová poptávka z VisionHome e-shopu</h2>
    <p><strong>👤 Jméno:</strong> ${formData.jmeno}</p>
    <p><strong>📧 E-mail:</strong> ${formData.email}</p>
    <p><strong>📞 Telefon:</strong> ${formData.telefon}</p>
    <p><strong>🏢 Firma:</strong> ${formData.firma || "-"}<br/>
    <strong>🏠 Adresa:</strong> ${formData.adresa}</p>

    <hr style="margin:16px 0;"/>

    <h3>🛒 Objednané položky:</h3>
    <table border="1" cellpadding="6" cellspacing="0" style="border-collapse:collapse;width:100%;font-family:sans-serif;">
      <thead style="background:#c6ff00;color:#000;">
        <tr>
          <th align="left">Produkt</th>
          <th align="right">Množství</th>
          <th align="right">Cena/ks</th>
          <th align="right">Celkem</th>
        </tr>
      </thead>
      <tbody>
        ${cartItems
          .map(
            (item) => `
            <tr>
              <td>${item.name} (${item.package})</td>
              <td align="right">${item.packageCount}× ${item.valuePerPack} ${item.unit}</td>
              <td align="right">${item.unit_price_with_vat.toFixed(2)} Kč</td>
              <td align="right"><strong>${item.totalPrice.toFixed(2)} Kč</strong></td>
            </tr>`
          )
          .join("")}
      </tbody>
    </table>

    <h3 style="margin-top:12px;">💰 Celkem: ${totalPrice.toFixed(2)} Kč s DPH</h3>
  `;

  try {
    const res = await fetch("/api/send-mail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        subject: "Nová poptávka z VisionHome e-shopu",
        html,
        from: formData.email,
      }),
    });

    if (res.ok) {
      alert("✅ Děkujeme! Poptávka byla úspěšně odeslána.");
      localStorage.removeItem("visionhome_cart");
      setCartItems([]);
      setFormData({ jmeno: "", email: "", telefon: "", firma: "", adresa: "" });
    } else {
      throw new Error("Chyba odeslání");
    }
  } catch (err) {
    console.error(err);
    alert("❌ Chyba při odesílání. Zkuste to prosím znovu.");
  }
};

  const groups = [...new Set(products.map((p) => p.group))];
  const openProduct = (p) => {
    setSelectedProduct(p);
    setPackageCount("");
  };

  return (
    <div
      className="min-h-screen text-white bg-cover bg-center"
      style={{ backgroundImage: "url('/bg.png')", backgroundColor: "#0f1812" }}
    >
      {/* NAVIGACE */}
      <header className="sticky top-0 z-40 backdrop-blur bg-black/60 border-b border-white/10 mb-8">
  <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
    <a href="/" className="flex items-center gap-3">
      <div className="w-9 h-9 rounded-xl bg-[#C6FF00] grid place-items-center ring-1 ring-black/10">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="black" className="w-5 h-5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 9.75L12 4.5l9 5.25M4.5 10.5v9.75h15V10.5M9 21V12h6v9" />
        </svg>
      </div>
      <div>
        <div className="text-lg font-bold tracking-tight">VisionHome</div>
        <div className="text-xs text-white/60 -mt-0.5">
          Materiály • Poradenství • Finance • Reality
        </div>
      </div>
    </a>
  </div>
</header>

      {/* INFO LIŠTA */}
      <div className="bg-gradient-to-r from-lime-400/20 via-lime-500/10 to-transparent text-center py-2 text-sm font-medium text-lime-300 tracking-wide">
        🚚 Doprava po celé ČR zdarma | 🧱 Individuální cenové nabídky na míru od 200 m²
      </div>

      {/* SEKCE – ZASLAT NABÍDKU KE KONTROLE */}
      <section className="max-w-[1400px] mx-auto px-6 py-10 lg:py-14">
        <h2 className="text-3xl font-bold text-lime-400 text-center mb-10 drop-shadow-[0_0_10px_rgba(132,255,0,0.3)]">
          Zaslat nabídku ke kontrole
        </h2>

        <div className="grid lg:grid-cols-2 gap-10 mb-12">
          <div className="bg-black/60 border border-lime-400/40 rounded-2xl p-6 shadow-[0_0_25px_rgba(0,0,0,0.5)] hover:shadow-[0_0_35px_rgba(132,255,0,0.25)] transition-all">
            <h3 className="text-xl font-semibold mb-2">💬 Zkontrolujeme vaši nabídku materiálu</h3>
            <p className="text-gray-300 leading-relaxed">
              Zašlete nám svou cenovou nabídku na materiál — rádi ji přepočítáme a
              navrhneme <span className="text-lime-400 font-semibold">
                výhodnější a především levnější řešení
              </span>, které <span className="text-lime-400 font-semibold">
                neovlivní kvalitu
              </span>.
            </p>
          </div>

          <div className="bg-black/60 border border-lime-400/40 rounded-2xl p-6 shadow-[0_0_25px_rgba(0,0,0,0.5)] hover:shadow-[0_0_35px_rgba(132,255,0,0.25)] transition-all">
            <h3 className="text-xl font-semibold mb-2">🧱 Porovnáme nabídku s prací a materiálem</h3>
            <p className="text-gray-300 leading-relaxed">
              Pokud máte nabídku včetně realizace, připravíme pro vás{" "}
              <span className="text-lime-400 font-semibold">
                alternativu se stejnou či vyšší kvalitou práce
              </span>{" "}
              a <span className="text-lime-400 font-semibold">
                garantujeme levnější cenu s lepší kvalitou
              </span>.
            </p>
          </div>
        </div>

        {/* FORMULÁŘ – ODESLAT NABÍDKU KE KONTROLE */}
        <form
  onSubmit={async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const file = data.get("soubor");

    let attachments = [];
    if (file && file.size > 0) {
      const toBase64 = (f) =>
        new Promise((resolve, reject) => {
          const r = new FileReader();
          r.onload = () => resolve(r.result.split(",")[1]);
          r.onerror = reject;
          r.readAsDataURL(f);
        });

      attachments.push({
        filename: file.name,
        content: await toBase64(file),
        contentType: file.type,
        encoding: "base64",
      });
    }

    const html = `
      <h2>📎 Zaslaná nabídka ke kontrole (VisionHome)</h2>
      <p><strong>👤 Jméno:</strong> ${data.get("jmeno")}</p>
      <p><strong>📧 E-mail:</strong> ${data.get("email")}</p>
      <p><strong>📞 Telefon:</strong> ${data.get("telefon")}</p>
      <p><strong>📍 Lokalita projektu:</strong> ${data.get("lokalita")}</p>
    `;

    try {
      const res = await fetch("/api/send-mail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          subject: "Zaslaná nabídka ke kontrole – VisionHome",
          html,
          from: data.get("email"),
          attachments,
        }),
      });

      if (res.ok) {
        alert("✅ Děkujeme! Nabídka byla úspěšně odeslána.");
        form.reset();
      } else {
        alert("❌ Chyba při odesílání. Zkuste to prosím znovu.");
      }
    } catch (err) {
      console.error(err);
      alert("❌ Nepodařilo se odeslat. Zkuste to prosím znovu.");
    }
  }}
  className="bg-neutral-900 border border-lime-400/50 rounded-2xl p-6 lg:p-8 shadow-[0_0_30px_rgba(132,255,0,0.1)]"
>
  <div className="grid md:grid-cols-2 gap-4">
    <input type="text" name="jmeno" required placeholder="Jméno a příjmení"
      className="p-3 rounded bg-neutral-800 border border-neutral-700 text-white" />
    <input type="email" name="email" required placeholder="E-mail"
      className="p-3 rounded bg-neutral-800 border border-neutral-700 text-white" />
    <input type="tel" name="telefon" required placeholder="Telefon"
      className="p-3 rounded bg-neutral-800 border border-neutral-700 text-white" />
    <input type="text" name="lokalita" required placeholder="Lokalita projektu"
      className="p-3 rounded bg-neutral-800 border border-neutral-700 text-white" />
  </div>

  <div className="mt-4">
    <label className="block text-sm text-gray-300 mb-2">
      Přiložte cenovou nabídku (PDF, DOCX, JPG, PNG)
    </label>
    <input
      type="file"
      name="soubor"
      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
      required
      className="block w-full text-sm text-gray-300 border border-neutral-700 rounded-lg cursor-pointer bg-neutral-800 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-lime-400 file:text-black hover:file:bg-lime-300"
    />
  </div>

  <button
    type="submit"
    className="mt-6 w-full bg-lime-400 text-black font-semibold py-3 rounded-full hover:bg-lime-300 transition shadow-[0_0_20px_rgba(132,255,0,0.3)]"
  >
    📩 Odeslat nabídku ke kontrole
  </button>
</form>

      </section>

      {/* HLAVNÍ OBSAH – KATALOG + STICKY KOŠÍK */}
      <div className="mx-auto w-full max-w-[1400px] px-6 pb-14 flex flex-col lg:flex-row gap-8 lg:gap-10">
        {/* PRODUKTY */}
        <div className="flex-1">
          <h1 className="text-3xl lg:text-4xl font-extrabold tracking-tight mb-8 text-center lg:text-left text-lime-400 drop-shadow-[0_0_8px_rgba(185,255,0,0.4)]">
            Katalog produktů VisionHome
          </h1>

          {groups.map((group, idx) => (
            <section key={group} className="mb-12">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl lg:text-2xl font-semibold">{group}</h2>
                <div className="h-px flex-1 ml-4 bg-gradient-to-r from-lime-400/40 to-transparent" />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5 lg:gap-6">
                {products
                  .filter((p) => p.group === group)
                  .map((p) => (
                    <article
                      key={p.sku}
                      className="group relative rounded-2xl p-4 border border-white/10 bg-white/7.5 backdrop-blur-sm
                                 shadow-[0_6px_28px_rgba(0,0,0,.25)] hover:shadow-[0_10px_34px_rgba(185,255,0,.12)]
                                 transition-all hover:-translate-y-0.5"
                      style={{ background: "linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.03) 100%)" }}
                    >
                      <div className="absolute top-3 left-3 text-[11px] text-gray-300/90 px-2 py-[2px] rounded-full border border-white/15 bg-black/30">
                        {p.sku}
                      </div>

                      <div className="w-full h-44 flex items-center justify-center mb-3 rounded-xl bg-black/25 border border-white/10">
                        <img
                          src={p.image || "/images/noimage.png"}
                          alt={p.name}
                          className="w-auto h-32 object-contain transition-transform group-hover:scale-[1.03]"
                        />
                      </div>

                      <h3 className="text-base font-semibold leading-snug line-clamp-2 min-h-[2.5rem]">{p.name}</h3>
                      <p className="text-sm text-gray-400 mt-1">{p.package}</p>

                      <div className="mt-3 flex items-end justify-between">
                        <p className="text-lg font-bold text-lime-400">
                          {p.unit_price_with_vat.toFixed(2)} Kč{" "}
                          <span className="text-xs text-gray-400">/jednotku</span>
                        </p>
                        <button
                          onClick={() => openProduct(p)}
                          className="px-4 py-2 rounded-full bg-lime-400 text-black font-semibold hover:bg-lime-300 transition"
                        >
                          Poptat
                        </button>
                      </div>
                    </article>
                  ))}
              </div>

              {idx !== groups.length - 1 && (
                <div className="mt-8 h-px w-full bg-gradient-to-r from-transparent via-white/10 to-transparent" />
              )}
            </section>
          ))}
        </div>

        {/* STICKY KOŠÍK */}
        <aside className="w-full lg:w-[380px] lg:sticky lg:top-6 self-start">
          <div className="rounded-2xl border border-lime-400/60 bg-black/70 backdrop-blur-md shadow-[0_10px_30px_rgba(0,0,0,.45)] p-5">
            <h2 className="text-lg font-semibold text-lime-300 mb-4">Tvoje poptávka</h2>

            {cartItems.length === 0 ? (
              <p className="text-gray-400 text-sm">Košík je prázdný.</p>
            ) : (
              <>
                <div className="max-h-64 overflow-y-auto mb-4 space-y-3 pr-1">
  {cartItems.map((item) => (
    <div
      key={item.id}
      className="border-b border-neutral-700 pb-2 bg-black/20 rounded-xl p-2 hover:bg-black/40 transition"
    >
      <p className="font-semibold text-white text-sm">{item.name}</p>

      <p className="text-gray-300 text-xs mt-1">
        {item.packageCount}× balení ({item.valuePerPack} {item.unit}/bal)
        → <span className="text-white font-medium">celkem {item.totalUnits} {item.unit}</span>
      </p>

      <p className="text-gray-400 text-xs mt-1 italic line-clamp-2">
        {item.package}
      </p>

      <div className="flex justify-between items-center mt-2">
        <p className="font-bold text-lime-400 text-sm">
          {item.totalPrice.toFixed(2)} Kč
        </p>
        <button
          onClick={() => removeFromCart(item.id)}
          className="text-red-500 text-xs hover:text-red-400 transition"
        >
          Odebrat
        </button>
      </div>
    </div>
  ))}
</div>
{/* Souhrn objednávky */}
<div className="border-t border-neutral-700 pt-3 text-sm mb-4">
  <div className="flex justify-between text-gray-400 mb-1">
    <span>Celkem bez DPH:</span>
    <span>
      {(cartItems.reduce((sum, item) => sum + item.totalPrice / 1.21, 0)).toFixed(2)} Kč
    </span>
  </div>
  <div className="flex justify-between text-gray-400 mb-1">
    <span>DPH (21 %):</span>
    <span>
      {(cartItems.reduce((sum, item) => sum + item.totalPrice, 0) / 1.21 * 0.21).toFixed(2)} Kč
    </span>
  </div>
  <div className="flex justify-between text-lime-400 font-bold text-base mt-2">
    <span>Celkem s DPH:</span>
    <span>
      {(cartItems.reduce((sum, item) => sum + item.totalPrice, 0)).toFixed(2)} Kč
    </span>
  </div>
</div>




                <div className="text-right text-lime-400 font-semibold mb-4">
                  Celkem: {totalPrice.toFixed(2)} Kč s DPH
                </div>

                <form onSubmit={handleSubmit} className="bg-neutral-900 p-3 rounded-lg border border-neutral-800 space-y-2">
  <h3 className="text-lime-400 font-semibold mb-2 text-center">Kontaktní údaje</h3>

  {["jmeno", "email", "telefon", "firma", "adresa"].map((field) => (
    <input
      key={field}
      type={field === "email" ? "email" : field === "telefon" ? "tel" : "text"}
      name={field}
      placeholder={
        {
          jmeno: "Jméno a příjmení",
          email: "E-mail",
          telefon: "Telefon",
          firma: "Firma (nepovinné)",
          adresa: "Adresa a město",
        }[field]
      }
      value={formData[field]}
      onChange={handleChange}
      required={field !== "firma"}
      className="w-full p-2 text-sm rounded bg-neutral-800 border border-neutral-700 text-white"
    />
  ))}

  {/* 🟩 Nové pole pro tónované materiály */}
  <textarea
    name="poznamka"
    placeholder="Poznámka (např. barva tónovaného materiálu)"
    value={formData.poznamka || ""}
    onChange={handleChange}
    rows={2}
    className="w-full p-2 text-sm rounded bg-neutral-800 border border-neutral-700 text-white resize-none"
  />

  <button
    type="submit"
    className="w-full mt-2 bg-lime-400 text-black font-semibold py-2 rounded-lg hover:bg-lime-300"
  >
    Odeslat poptávku
  </button>
</form>

              </>
            )}
          </div>
        </aside>
      </div>

      {/* MODÁL – DETAIL PRODUKTU */}
      {selectedProduct && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-neutral-900 border border-lime-400 rounded-2xl p-6 w-[92%] max-w-md">
            <h2 className="text-lime-400 text-xl font-semibold mb-2">{selectedProduct.name}</h2>
            <img
              src={selectedProduct.image || "/images/noimage.png"}
              alt={selectedProduct.name}
              className="w-full h-48 object-contain mb-3"
            />
            <p className="text-gray-300 mb-1">Balení: {selectedProduct.package}</p>
            <p className="text-lime-400 font-bold mb-4">
              {selectedProduct.unit_price_with_vat.toFixed(2)} Kč s DPH / jednotku
            </p>

            <label className="block text-gray-400 text-sm mb-1">Počet balení:</label>
            <input
              type="number"
              min="1"
              inputMode="numeric"
              placeholder="např. 3"
              value={packageCount}
              onChange={(e) => setPackageCount(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  addToCart(selectedProduct, packageCount);
                }
              }}
              className="w-full p-2 mb-4 rounded bg-neutral-800 border border-neutral-700 text-white"
            />

            <div className="flex justify-between gap-2">
              <button
                onClick={() => addToCart(selectedProduct, packageCount)}
                className="bg-lime-400 text-black font-semibold px-4 py-2 rounded-lg hover:bg-lime-300"
              >
                Přidat do poptávky
              </button>
              <button
                onClick={() => setSelectedProduct(null)}
                className="bg-neutral-800 text-white font-semibold px-4 py-2 rounded-lg hover:bg-neutral-700"
              >
                Zavřít
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShopPage;

